import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function DeliveryTruck(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "DeliveryTruck", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.5 15.75h8.648a3 3 0 0 1 2.97 2.576l1.132 7.924h1.5a3 3 0 0 1 3 3v7.5a1.5 1.5 0 0 1-1.5 1.5H28.5v-22.5Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.25 15.75v9a1.5 1.5 0 0 0 1.5 1.5h7.5l-1.132-7.924a3 3 0 0 0-2.97-2.576H32.25Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.25 11.25h21a3 3 0 0 1 3 3v24h-24a3 3 0 0 1-3-3v-21a3 3 0 0 1 3-3Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M11.25 42.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M11.25 40.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx("path", { d: "M36.75 42.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z", fill: theme.vars.palette.primary.dark }),
    /* @__PURE__ */ jsx("path", { d: "M36.75 40.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx("path", { d: "M29.265 30h-27v1.5h27V30Z", fill: theme.vars.palette.primary.light })
  ] });
}
DeliveryTruck.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "DeliveryTruck"
};
validateTidalLicense();
export {
  DeliveryTruck
};
//# sourceMappingURL=DeliveryTruck.js.map
